/* tslint:disable */
/* eslint-disable */
/**
 * Geocoding API
 * Telematics services geocoding API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LatLngLiteral
 */
export interface LatLngLiteral {
    /**
     * 
     * @type {number}
     * @memberof LatLngLiteral
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof LatLngLiteral
     */
    lng: number;
}

export function LatLngLiteralFromJSON(json: any): LatLngLiteral {
    return LatLngLiteralFromJSONTyped(json, false);
}

export function LatLngLiteralFromJSONTyped(json: any, ignoreDiscriminator: boolean): LatLngLiteral {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lng': json['lng'],
    };
}

export function LatLngLiteralToJSON(value?: LatLngLiteral | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lat': value.lat,
        'lng': value.lng,
    };
}


